import type { DestinationPlatform } from '../types';

/** The longest prompt proxima-audiences accepts for a preview. */
export const PROMPT_MAX_LENGTH = 2000;

/**
 * The platforms the Deliver-to form offers.
 *
 * TikTok and Google are left out until their deliveries are live.
 * Add a platform here to offer it again.
 * Destinations already saved on any platform still show on the detail page.
 */
export const LIVE_DELIVERY_PLATFORMS: readonly DestinationPlatform[] = ['meta'];

/** Where a brand accepts Meta's custom audience terms; `?act=<numeric id>` opens it on one ad account. */
export const META_CUSTOM_AUDIENCE_TOS_URL =
  'https://business.facebook.com/ads/manage/customaudiences/tos/';

/** How long the brand picker waits after the last keystroke before it searches. */
export const BRAND_SEARCH_DEBOUNCE_MS = 400;

/** The shortest search the brand picker sends, so focusing the field never lists every brand. */
export const BRAND_SEARCH_MIN_LENGTH = 2;
